import React from 'react';
import { Box } from '@mui/material';
import CIHAChartsContainer from '../Common/CIHAChartsContainer';
import FinancingWrapper from './index';

const Financing = () => {
    return (
        <Box>
            <Box className="content">
                <CIHAChartsContainer
                    title={'Financiamento / Fonte'}
                    className="services-container-dashboards"
                >
                    <FinancingWrapper />
                </CIHAChartsContainer>
            </Box>
        </Box>
    );
};

export default Financing;
